import { Injectable } from '@angular/core';
import { SecurityInfo, SymbolType } from '../../../../../../domain/symbol.domain';
import { OptionQuoteParams } from '../../../../../../domain/trading.domain';
import { OrderSecurity } from '../../../../../../domain/security.domain';
import {
  OrderItem,
  InsiderType,
  OptionExtendedTerms
} from '../../../../domain';

import { OrderEntryUtilityService } from '../../order-entry-utility.service';
import { BackendMapper } from '../../../domain/services.domain';
import { CreateOrderMapper } from './create-order-mapper.service';
import type { OptionFormModel } from '../../../domain/order-entry.domain';

@Injectable()
export class CreateOptionOrderMapper extends CreateOrderMapper<OptionFormModel> implements BackendMapper<OptionFormModel> {

  getMapperType(): OrderSecurity {
    return 'option';
  }

  getItems(formModel: OptionFormModel): Array<OrderItem> {
    return [{
      clientInfo: this.getOrderItemClientInfo(formModel.shareholderStatus),
      quantity: formModel.orderQuantity,
      extendedTerms: this.getOrderItemExtendedTerms(formModel),
      security: this.getOrderItemSecurity(formModel)
    }];
  }

  protected getOrderItemExtendedTerms(formModel: OptionFormModel): OptionExtendedTerms {
    const extendedTerms = {
      allOrNone: formModel.orderAllOrNone,
      goodTill: formModel.orderGoodTil,
      goodTillDate: formModel.orderGoodTilDate,
      orderAction: formModel.orderAction,
      orderType: formModel.orderPrice
    } as OptionExtendedTerms;

    OrderEntryUtilityService.setEquityPrice(extendedTerms,
      formModel.orderPrice,
      formModel.orderPriceAmount);

    return extendedTerms;
  }

  protected getOrderItemSecurity(formModel: OptionFormModel): SecurityInfo {
    let securityInfo = {
      symbol: formModel.selectedSymbol.symbol,
      market: formModel.selectedSymbol.market,
      type: SymbolType.OPTION
    };
    if (formModel.optionQuoteParams !== undefined) {
      securityInfo = Object.assign<SecurityInfo, { displayTicker: string }>(
        securityInfo,
        this.getDisplayTicker(formModel, securityInfo.symbol)
      );
    }
    return securityInfo;
  }

  protected getOrderItemClientInfo(status: InsiderType): { insiderInfo: InsiderType; solicited: boolean } {
    return {
      insiderInfo: status === undefined ? null : status,
      solicited: false
    };
  }

  private getDisplayTicker(formModel: OptionFormModel, symbol: string): { displayTicker: string } {
    return {
      displayTicker: formModel.optionQuoteParams.displayTicker !== undefined ?
        formModel.optionQuoteParams.displayTicker :
        this.serializeSymbol(formModel.optionQuoteParams, symbol)
    };
  }

  private serializeSymbol(optionQuoteParams: OptionQuoteParams, underlyingCompany: string): string {
    const type = optionQuoteParams.optionType.charAt(0);
    const date = OrderEntryUtilityService.serializeDateToOptionDate(optionQuoteParams.expiryDate);
    return `${underlyingCompany} ${type} ${date} ${optionQuoteParams.strikePrice.toFixed(2)}`;
  }
}

